import { useSelector, TypedUseSelectorHook } from 'react-redux';
import { RootState } from '../redux-manager';

export const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;
